import { configApiRef, useApi } from '@backstage/core-plugin-api';

/**
 * ★ 항목 15 / D27 (WO-onprem-clean-slate · 2026-09-21): GCP Cost 기능 플래그.
 *   `arcus.features.gcpCost` 미설정 = true → GCP 거동 0. 온프렘 = values 오버레이가 false
 *   (백엔드 gcp-cost 라우터도 arcus.gcp 미설정 시 미등록 = 15-b).
 *   소비처 3 = EntityPage Cost 탭 · Root 사이드바 `admin/gcp-cost` 링크 · App `/admin/gcp-cost` 라우트.
 */
export const useGcpCostEnabled = (): boolean => {
  const configApi = useApi(configApiRef);
  return configApi.getOptionalBoolean('arcus.features.gcpCost') ?? true;
};

/** 사이드바 메뉴 항목의 `to` 가 GCP Cost 화면인지 (`admin/gcp-cost` · `/admin/gcp-cost`). */
export const isGcpCostMenuTarget = (to?: string): boolean =>
  (to ?? '').replace(/^\/+/, '') === 'admin/gcp-cost';
